import React from "react";
import styles from "./TryFreeFooter.module.scss";

export default function TryFreeFooter({
    title,
    subtitle,
    buttonText,
    buttonLink,
}) {
    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <div className={styles.accent} />
                <div className={styles.content}>
                    {title && <h3 className={styles.title}>{title}</h3>}
                    {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
                    <a
                        className={styles.button}
                        href={
                            buttonLink || "https://admin.laufid.is/registration"
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {buttonText || "Book a trial"}
                    </a>
                </div>
            </div>
        </div>
    );
}
